import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { Link } from "react-router-dom";
import { SimpleLoading, PromotionalFooterPure, GridHLPure } from "../../pures";
import {
  HeaderHLPure,
  ButtonAddHLPure,
  FilterHLPure,
  GridGLPure,
  SearchBarHLPure,
  DropDownBtnHLPure,
  DataPickerHLPure,
  Traslates,
  DialogSystemGLPure,
} from "../../pures";
import "./followup-contracts.css";
import { NIL as NIL_UUID } from "uuid";
import { ContractBlueIcon, newConfigurationIcon, searchIcon } from "../../../assets/logos/icons";
import { useHistory } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import { search } from "../../../assets/logos/icons";

const FollowUpContractsView = (props) => {
  const {
    disableLawyer,
    disableUser,
    questionnaires,
    lawyers,
    users,
    companies,
    contractStatus,
    filterCompany,
    totalContract,
    totalPercentCotract,
    sendToNextPage
  } = props;
  const { t } = useTranslation();
  let history = useHistory();

  const [filterCompanies, setFilterCompanies] = useState([]);
  const [filterQuestionnaires, setFilterQuestionnaires] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState([]);
  const [selectedContractStatus, setselectedContractStatus] = useState(
    props.contractStatusValue
  );

  const [selectedContract, setSelecteContract] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [nameComponentContract, setNameComponentContract] = useState("");
  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: "",
  });

  const [company, setCompany] = useState('1');
  const [questionnaire, setQuestionnaire] = useState(NIL_UUID);
  const [lawyer, setLawyer] = useState(NIL_UUID);
  const [user, setUser] = useState(NIL_UUID);
  const [firstDate, setFirstDate] = useState(
    getFirstDayOfYear(new Date().getFullYear())
  );
  const [secondDate, setSecondDate] = useState(new Date());

  const [clientValue, setClientValue] = useState(props.clientValue);

  const showColumn3 = useMediaQuery("(min-width:920px)");
  const showActions = useMediaQuery("(min-width:721px)");

  useEffect(() => {
    setStatusFilter(contractStatus);
  });

  useEffect(() => {
    if (selectedContract.id) {
      sendToNextPage(selectedContract.id)
    }
  }, [selectedContract]);

  useEffect(() => {
    // let companyCopy = [...filterCompany];
    // let dataUpdateFilter = templateCopy.filter(
    //     (template) => template.active === true
    // )
    filterCompany.sort(function (a, b) {
      return new Date(b.createdDate) - new Date(a.createdDate);
    });

    setselectedContractStatus(props.contractStatusValue || "Todos los Estatus");
    setLawyer(props.lawyersValue || NIL_UUID);
    setUser(props.clientValue || NIL_UUID);
    setFilterCompanies(filterCompany);
  }, [filterCompany]);

  const strToboolean = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    if (value === 0) value = null;
    if (value === "0") value = null;
    return value;
  };

  //Filter Function, get selected value
  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value);
    // const selectedOption = e.target.value;
    setselectedContractStatus(selectedOption);
  };

  //Search Function, get value search input
  const searchChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  //Search Function, search elements and update grid /ULTRA MEGA FILTRO
  useEffect(() => {
    let filterCopy = [...filterCompany];
    let dataUpdateFilter =
      selectedContractStatus !== "Todos los Estatus"
        ? filterCopy.filter(
          (filter) => filter.statusWorkflow === selectedContractStatus
        )
        : filterCompany;

    dataUpdateFilter = dataUpdateFilter.filter((filter) => {
      return (
        // template.description.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 ||
        filter.name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
      );
    });

    dataUpdateFilter =
      company !== '1'
        ? dataUpdateFilter.filter(
          (filter) => filter.questionnaire.companyId === company
        )
        : dataUpdateFilter;

    dataUpdateFilter =
      questionnaire !== NIL_UUID
        ? dataUpdateFilter.filter(
          (filter) => filter.questionnaireId === questionnaire
        )
        : dataUpdateFilter;

    dataUpdateFilter =
      lawyer !== NIL_UUID
        ? dataUpdateFilter.filter(
          (filter) => filter.userLawyerId === Number(lawyer)
        )
        : dataUpdateFilter;

    dataUpdateFilter =
      user !== NIL_UUID
        ? dataUpdateFilter.filter(
          (filter) => filter.userCreatorId === Number(user)
        )
        : dataUpdateFilter;

    dataUpdateFilter.sort(function (a, b) {
      return new Date(b.createdDate) - new Date(a.createdDate);
    });

    setFilterCompanies(dataUpdateFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    searchValue,
    selectedContractStatus,
    company,
    questionnaire,
    lawyer,
    user,
  ]);


  useEffect(() => {
    let filterQuestionnaire = [...questionnaires];

    filterQuestionnaire = company !== '1'
      ? filterQuestionnaire.filter(
        (filter) => filter.companyId === company || filter.id === NIL_UUID
      )
      : null;

    setFilterQuestionnaires(filterQuestionnaire)
  }, [
    company,
  ]);

  //CAMBIO DE PANTALLA
  const setHeaderTitle = () => {
    const name = headerTitleinDetail.name || nameComponentContract;
    switch (name) {
      case "":
        return t("followupContracts.title");
      // case "Solicitar-contrato":
      //   return t("Solicitar Contrato");
      case "Ver detalles":
        return t("followupContracts.title");
      default:
        return t("followupContracts.title");
    }
  };

  useEffect(() => {
    if (headerTitleinDetail.clicked) {
      setHeaderTitle();
    }
    setHeaderTitle();
  }, [nameComponentContract, headerTitleinDetail]);

  //ALL HANDLE CHANGES

  const handleChangeCompany = (e) => {
    setCompany(e.target.value);
  };

  const handleChangeQuestionnaire = (e) => {
    setQuestionnaire(e.target.value);
  };

  const handleChangeLawyer = (e) => {
    setLawyer(e.target.value);
  };

  const handleChangeUser = (e) => {
    setUser(e.target.value);
  };

  const handleChangeFirstDate = (e) => {
    setFirstDate(e.target.value);
  };

  function handleChangeSecondDate(e) {
    setSecondDate(e.target.value);
  }

  function getFirstDayOfYear(year) {
    return new Date(year, 0, 1);
  }

  const Reload = async (e) => {
    props.toggleLoadingRequesting(true);
    await props.getNewContracts(firstDate, secondDate);
    props.toggleLoadingRequesting(false);
  };

  const handleSendNegotiatecontract = (dataItem) => {
    history.push(`/consult-negotiation/${dataItem.id}/${dataItem.workflowExecutionId}`)
  }

  return (
    <div className="digitalContractTemplates-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container
          xs={12}
          lg={12}
          md={12}
          sm={12}
          spacing={4}
          className="digitalContractTemplates-container"
        >
          {/* </Container body> */}
          <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
            {/**Container header**/}
            <Grid
              item
              lg={12}
              md={12}
              xs={12}
              sm={12}
            >
              <HeaderHLPure title={setHeaderTitle()} />
            </Grid>
            {/**Container para los items**/}
            <Grid
              container
              className="digitalContractTemplates-body"
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
            >
              {/*Container primera seccion de items, fila*/}
              {/* {showDetails && selectedContract ? (
                                <></>
                                // <TemplatesConfigurationsView
                                //     nameComponentTemplate={nameComponentTemplate}
                                //     selectedTemplate={selectedTemplate}
                                //     hideShowDetails={() => {
                                //         setShowDetails(false);
                                //         setNameComponentTemplate("");
                                //         setHeaderTitleinDetail({ clicked: false, name: "" });
                                //         setSearchValue("")
                                //         setselectedContractStatus("")
                                //     }}
                                //     token={props.token}
                                //     options={companies}
                                //     clientId={clientId}
                                //     setHeaderTitleinDetail={setHeaderTitleinDetail}
                                //     formatVariables={formatVariables}
                                //     validators={validators}
                                //     forceRefresh={props.forceRefresh}
                                //     getVariablesFromDoc={props.getVariablesFromDoc}
                                //     showLoadingRequesting={props.showLoadingRequesting}
                                //     showCompletedRequesting={props.showCompletedRequesting}
                                //     message={props.message}
                                //     showErrorRequesting={props.showErrorRequesting}
                                //     toggleLoadingRequesting={props.toggleLoadingRequesting}
                                //     toggleCompletedRequesting={props.toggleCompletedRequesting}
                                //     toggleErrorRequesting={props.toggleErrorRequesting}
                                //     clientTemplates={clientTemplates}
                                // />
                            ) : ( */}
              <>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="followupContracts-navbar"
                >
                  <Link to="/contract-request">
                    <ButtonAddHLPure
                      nameBtn={t("followupContracts.NewContract")}
                      onClickBtn={() => {
                        setNameComponentContract("Solicitar-contrato");
                        setShowDetails(true);
                      }}
                      iconAdd={true}
                    />
                  </Link>

                  <SearchBarHLPure
                    // placeholder={t("Buscar Contratos")}
                    onSearchChange={(e) => searchChange(e)}
                  />

                  <FilterHLPure
                    // dataCombo={options}
                    labelFilter=""
                    options={statusFilter}
                    nameOption="workflowExecutionName"
                    valueItem="workflowExecutionName"
                    onFilterChange={(event) => filterChange(event)}
                    optionsValue={selectedContractStatus}
                  />
                </Grid>
                <Grid
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="followUpContract-TotalContractGrid"
                >
                  <Grid
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="followUpContrats-TotalContract-Right"
                  >
                    <img src={ContractBlueIcon} className="followUpContrats-TotalContract-icon" />
                    <label style={{ fontSize: "24px" }}>
                      Total de Contratos {totalContract}
                    </label>
                  </Grid>
                  <Grid
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="followUpContrats-TotalContract-Left"
                  >
                    <CircularProgressbar
                      value={parseFloat(totalPercentCotract)}
                      className="followUpContrats-TotalContract-icon"
                    />
                    <label style={{ fontSize: "24px" }}>
                      Contratos entregados {totalPercentCotract}
                    </label>
                  </Grid>
                </Grid>

                <Grid
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="followUpContract-FilterGrid"
                >
                  <Grid
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="followUpContract-FilterGridDropdown"
                  >
                    <DropDownBtnHLPure
                      labelDropDown={"Empresa"}
                      optionsDropDown={companies}
                      valueItem={"companyId"}
                      optionsValue={company}
                      nameOption={"name"}
                      onDropDownChange={(e) => handleChangeCompany(e)}
                    ></DropDownBtnHLPure>
                  </Grid>
                  <Grid
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="followUpContract-FilterGridDropdown"
                  >
                    <DropDownBtnHLPure
                      labelDropDown={"Tipo de Contrato"}
                      optionsDropDown={filterQuestionnaires || questionnaires}
                      valueItem={"id"}
                      optionsValue={questionnaire}
                      nameOption={"name"}
                      onDropDownChange={(e) => handleChangeQuestionnaire(e)}
                    ></DropDownBtnHLPure>
                  </Grid>
                  <Grid
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="followUpContract-FilterGridDropdown"
                  >
                    <DropDownBtnHLPure
                      labelDropDown={"Abogado"}
                      optionsDropDown={lawyers}
                      valueItem={"userId"}
                      optionsValue={lawyer}
                      nameOption={"name"}
                      disable={disableLawyer}
                      onDropDownChange={(e) => handleChangeLawyer(e)}
                    ></DropDownBtnHLPure>
                  </Grid>
                  <Grid
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="followUpContract-FilterGridDropdown"
                  >
                    <DropDownBtnHLPure
                      labelDropDown={"Solicitante"}
                      optionsDropDown={users}
                      valueItem={"userId"}
                      optionsValue={user}
                      nameOption={"name"}
                      disable={disableUser}
                      onDropDownChange={(e) => handleChangeUser(e)}
                    ></DropDownBtnHLPure>
                  </Grid>
                  <Grid
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="followUpContract-FilterGridDropdown"
                  >
                    <Traslates>
                      <DataPickerHLPure
                        labelDataPicker={"Fecha solicitud del"}
                        valueDate={firstDate}
                        handleChangeDate={(e) => handleChangeFirstDate(e)}
                        format={"dd-MMM-yyyy"}
                      ></DataPickerHLPure>
                    </Traslates>
                  </Grid>
                  <Grid
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="followUpContract-FilterGridDropdown followUpContract-FilterGrid-date"
                  >
                    <Traslates>
                      <DataPickerHLPure
                        labelDataPicker={"Fecha solicitud al"}
                        valueDate={secondDate}
                        limitDate={firstDate}
                        format={"dd-MMM-yyyy"}
                        handleChangeDate={(e) => handleChangeSecondDate(e)}
                      ></DataPickerHLPure>
                    </Traslates>
                    <div onClick={Reload}>
                      <img
                        alt="config-icon"
                        src={search}
                        className="followup-avatar-profile-icon"
                        title="Configuración"
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid
                  item
                  // lg={12}
                  // md={12}
                  // sm={12}
                  // xs={12}
                  className="digitalContractTemplates-gridContainer"
                >
                  <GridHLPure
                    {...props}
                    dataGrid={filterCompanies}
                    skip={0}
                    take={6}
                    filter={true}
                    onFilterChange={filterChange}

                    titleRow1={t("followupContracts.titleGrid1")}
                    fieldRow1={"name"}
                    fieldTitle={"name"}
                    textSubtitle={showActions ? "Última modificación el " : ""}
                    fieldSubtitle={"updatedDate"}
                    labelsColumnsNoPadding
                    styleHeader1={{ marginLeft: "20px" }}
                    widthHeader={"digitalContractTemplates-contractsGrid-col1"}
                    styleCol1={"digitalContractTemplates-contractsGrid-col1"}

                    columnThree={showColumn3}
                    fieldRow3={"description"}
                    titleRow3={"Tipo de contrato"}
                    styleCol3={"digitalContractTemplates-contractsGrid-col3"}

                    columnFour
                    titleRow4={showActions ? t("followupContracts.titleGrid4") : ""}
                    iconFourthActive
                    labelFourthActions={"Ver detalles"}
                    widthHeaderCol4={"digitalContractTemplates-contractsGrid-col4"}
                    styleCol4={"digitalContractTemplates-contractsGrid-col4"}

                    activeDialog1
                    labelOneActions = {t("contractRequestStatusView.btn.request.negotiation")}
                    btnOpenDialog1={(dataItem) =>handleSendNegotiatecontract(dataItem)}

                    onSelectedItem={setSelecteContract}
                    setShowDetails={setShowDetails}
                    setNameComponentUser={setNameComponentContract}
                  />
                </Grid>
                <DialogSystemGLPure
                  showLoadingRequesting={props.showLoadingRequesting}
                  showCompletedRequesting={props.showCompletedRequesting}
                  showErrorRequesting={props.showErrorRequesting}
                  toggleLoadingRequesting={props.toggleLoadingRequesting}
                  toggleCompletedRequesting={props.toggleCompletedRequesting}
                  toggleErrorRequesting={props.toggleErrorRequesting}
                  // message={props.message}
                />
              </>
              {/* )} */}
              {/*Seccion de fila para footer */}
              <Grid item xs={12} lg={12} md={12} sm={12}>
                <PromotionalFooterPure />
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
    </div>
  );
};

export default FollowUpContractsView;
